import { Globe } from 'lucide-react';
import { SUPPORTED_LANGS, getLangLabel } from '@/i18n';

export default function LanguageSelector({ currentLang, onChangeLang }) {
  return (
    <div className="relative inline-flex items-center">
      <Globe className="w-4 h-4 text-gray-400 mr-1" />
      <select
        value={currentLang}
        onChange={(e) => onChangeLang(e.target.value)}
        className="bg-transparent text-gray-300 text-sm font-medium appearance-none cursor-pointer pr-6 focus:outline-none hover:text-white transition-colors"
        data-testid="language-selector"
      >
        {SUPPORTED_LANGS.map((lang) => (
          <option key={lang} value={lang} className="bg-[#111] text-white">
            {getLangLabel(lang)}
          </option>
        ))}
      </select>
      <div className="pointer-events-none absolute right-0 flex items-center text-gray-400">
        <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
        </svg>
      </div>
    </div>
  );
}
